/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=6579d9d6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/haonanzeng/Desktop/PigGTEx-Portal/piggtex-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__